import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { TicketStatus } from '../../../models/tickets/ticket-status';
import { Ticket } from '../../../models/tickets/ticket';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-support-ticket',
    templateUrl: './support-ticket.component.html',
    styleUrls: ['./support-ticket.component.scss'],
    standalone: false
})
export class SupportTicketComponent implements OnInit {

  readonly statusClass = {
    [TicketStatus.NEW]: 'accent-bg',
    [TicketStatus.PROGRESS]: 'cyan-bg',
    [TicketStatus.RESOLVED]: 'green-1-bg',
  };

  @Input() ticket: Ticket;

  constructor() {
  }

  ngOnInit(): void {
  }

}
